<template>
  <CRow>
    <div>
      <CModal
          :title="
          submitType === 'Update'
            ? $lang.recruitment_report.crud.edit
            : $lang.recruitment_report.crud.view"
          size="lg"
          :show.sync="largeModal"
          :no-close-on-backdrop="true"
          color="primary"
      >
        <div class="form-group" :class="{ 'form-group--error': '' }">
          <label class="form__label">
            {{ $lang.recruitment_report.form.reason }} :
          </label>
          <div>
            {{ reason }}
          </div>
        </div>
        <div class="form-group">
          <label class="form__label"
          >{{ $lang.recruitment_report.form.description }} :
          </label>
          <div>
            {{ ViewResponse }}
          </div>
        </div>
        <template #footer style="display: none">
          <CButton
              @click="darkModal = false"
              color="danger"
              style="display: none"
          >Discard
          </CButton
          >
          <CButton
              @click="darkModal = false"
              color="success"
              style="display: none"
          >Accept
          </CButton
          >
        </template>
      </CModal>
    </div>
    <CCol col="12">
      <div class="row">
        <CCol sm="6" class="align-self-center"></CCol>
        <CCol sm="6" class="align-self-center">
          <div class="text-sm-right mt-3 mt-sm-0">
            <CButtonGroup class="file-export">
              <CButton color="secondary" disabled>
                {{ $lang.buttons.export.title }}
              </CButton>
              <CButton
                  color="danger"
                  v-c-tooltip="$lang.buttons.export.pdf"
                  v-on:click="
                  exports(self, 'pdf', module, 'Recruitment Report', self.editId)
                "
              >
                <i class="fas fa-file-pdf"></i>
              </CButton>
              <VueJsonToCsv
                  class="btn btn-success"
                  v-c-tooltip="$lang.buttons.export.excel"
                  :json-data="json_data"
                  :labels="json_label"
                  :csv-title="json_title"
              >
                <i class="fas fa-file-excel"></i>
              </VueJsonToCsv>
            </CButtonGroup>
          </div>
        </CCol>
      </div>
      <CAlert
          color="success"
          closeButton
          :show.sync="dismissCountDownS"
          fade
      >{{ alertMessage }}
      </CAlert
      >
      <div id="people">
        <v-server-table
            :columns="columns"
            :url="listUrl"
            :options="options"
            ref="myTable"
            @loaded="
            exports(self, 'Excel', module, 'Recruitment Report', self.editId)
          "
        >
          <template #actions="data">
            <CButton
                color="primary"
                v-c-tooltip="$lang.recruitment_report.crud.view"
                v-on:click="viewResponse(data.row.id)"
            >
              <i class="fas fa-eye"></i>
            </CButton>
            <!--<CButton color="success" v-c-tooltip="$lang.buttons.general.crud.edit"  v-on:click="editTableRow(data.row.id)"><i class="fas fa-pencil-alt"></i></CButton>-->
          </template>
        </v-server-table>
      </div>
    </CCol>
  </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import {RecruitmentReportList} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import VueJsonToCsv from "vue-json-to-csv";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);
export default {
  name: "RecruitmentReport",
  mixins: [Mixin],
  components: {
    VueJsonToCsv,
  },
  data() {
    return {
      submitted: false,
      reportId: "",
      reason: "",
      json_data: [],
      json_label: {},
      json_title: "",
      ViewResponse: "",
      submitType: "",
      largeModal: false,
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      items: [],
      activePage: 1,
      listUrl: "",
      columns: ["reason", "username", "createdAt", "actions"],
      options: {
        headings: {
          reason: this.$lang.recruitment_report.table.reason,
          username: this.$lang.recruitment_report.table.username,
          createdAt: this.$lang.recruitment_report.table.addedAt,
          actions: this.$lang.common.general.actions,
        },
        editableColumns: ["name", "isVerified"],
        sortable: ["name", "isVerified"],
        filterable: ["name", "isVerified"],
      },
      module: RecruitmentReportList,
    };
  },
  created() {
    let self = this;
    self.editId = this.$route.params.id;
    self.listUrl = "/job-opening/report/list/" + self.editId;
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    viewResponse(item) {
      let self = this;
      self.reportId = item;
      axios
          .get(this.viewUrlApi(this.module, self.reportId), self.model)
          .then(function (response) {
            if (response) {
              const responseData = response.data.data;
              self.ViewResponse = responseData.description;
              self.reason = responseData.reason;
            } else {
              self.data = [];
            }
          });
      self.largeModal = true;
    },
  },
};
</script>
